import {
  HydrationRoles,
  HydrationSources,
} from 'src/app/core/store/common/interfaces/hydration-status-store.interface';
import { IOnboardingHydration } from 'src/app/core/store/common/interfaces/hydration.interface';

export abstract class AbstractHydrationService {
  abstract HydrateOnboardingStore(
    hydrationRole: HydrationRoles,
    hydrationSource: HydrationSources,
  ): Promise<IOnboardingHydration>;
}
